import { useAction, useAtom } from "@reatom/npm-react";
import s from "./style.module.scss";
import {
  isCardViewAtom,
  updateCardView,
} from "../../core/reatom/state/CardView";
import clsx from "clsx";
import { useEffect, useState } from "react";

export const CardViewSwithcer = ({
  scrollY,
  className,
}: {
  scrollY: number;
  className?: string;
}) => {
  const handleUpdate = useAction(updateCardView);
  const [isCardView] = useAtom(isCardViewAtom);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const scrollDelta = Math.abs(scrollY - lastScrollY);

  useEffect(() => {
    if (scrollDelta > 50) {
      if (scrollY > lastScrollY) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(scrollY);
    }
  }, [scrollY, lastScrollY]);

  return (
    <div
      className={clsx(s.cardViewSwithcer, !isVisible && s.hidden, className)}
      id="viewSwitcher"
    >
      <div className={clsx(s.switcher, isCardView && s.switcherRight)}></div>
      <button className={s.button} onClick={() => handleUpdate(false)}>
        <p className={clsx(!isCardView && s.active)}>Плитка</p>
      </button>
      <button className={s.button} onClick={() => handleUpdate(true)}>
        <p className={clsx(isCardView && s.active)}>Список</p>
      </button>
    </div>
  );
};
